import axios from "./axios";

export default {
    async createAccountingPeriod( data ) {
        try {
            
            const options = { 
                method: 'POST',
                url: '/accountingperiod',
                headers: {
                    'content-type': 'application/json'
                },
                data
            }
            const { data: responseData } = await axios( options );
            const { success, status } = responseData;

            if ( !success ) {
                if( status === 400 ) {
                    return responseData;
                } else {
                    throw new Error( responseData.message );
                }
            }
    
            return responseData;
        } catch (error) {
            throw new Error(`${error.message}`);
        }
    },
    async modifyAccountingPeriod( data ) {
        try {
            
            const options = { 
                method: 'PATCH',
                url: '/accountingperiod',
                headers: {
                    'content-type': 'application/json'
                },
                params: data
            }
            const { data: responseData } = await axios( options );
            const { success } = responseData;
    
            if ( !success ) {
                throw new Error( responseData.message );
            }
    
            return responseData;
        } catch (error) {
            throw new Error(`${error.message}`);
        }
    },
    async getAccountingPeriod( data ) {
        try {
            const options = { 
                method: 'GET',
                url: '/accountingperiod',
                headers: {
                    'content-type': 'application/json'
                },
                params: data
            }
            const { data: responseData } = await axios( options );
            const { success } = responseData;
    
            if ( !success ) {
                throw new Error( responseData.message );
            }

            return responseData;
        } catch (error) {
            throw new Error(`${error.message}`);
        }
    },
    async getBalances( id_accounting_period ) {
        try {
            const options = {
                method: 'GET',
                url: `/accountingperiod/${id_accounting_period}/balances`,
                headers: {
                    'content-type': 'application/json'
                }
            }

            const { data: responseData } = await axios( options );
            const { success } = responseData;

            if ( !success ) {
                throw new Error( responseData.message );
            }

            return responseData;
        } catch (error) {
            throw new Error(`${error.message}`);
        }
    },
    async getClosingBalanceJobStatus( jobId ) {
        try {
            const options = {
                method: 'GET',
                url: `/accountingperiod/getclosingbalance-job/${jobId}`,
                headers: {
                    'content-type': 'application/json'
                }
            };

            const { data: responseData } = await axios( options );

            return responseData;
        } catch (error) {
            if (error.response) {
                throw error.response.data;
            }

            throw {
                status: 500,
                success: false,
                message: error.message
            };
        }
    }
}
